import { RAW_LLM_KEYWORDS } from './llmKeywords';

export const PRIMARY_KEYWORDS = [
  'paper bottle',
  'paper bottle India',
  '100% compostable paper bottle',
  'paper bottle manufacturer',
  'paper bottle manufacturer India',
  'paper bottle supplier',
  'paper bottle supplier India',
  'compostable paper bottle',
  'paper water bottle',
  'paper bottle for water',
  'paper bottle for juice',
  'paper bottle 500ml',
  'paper bottle 750ml',
  'paper bottle 1L',
];

export const SECONDARY_KEYWORDS = [
  'compostable bottle',
  'compostable bottle India',
  'sustainable packaging India',
  'compostable beverage packaging India',
  'biodegradable bottle suppliers India',
  'sustainable bottle manufacturer India',
  'plastic-free packaging solutions for beverages',
  'eco-friendly packaging',
  'compostable packaging',
  'green packaging',
  'zero waste packaging',
  'bamboo bottle',
  'sugar cane bottle',
  'CIPET certified',
  'CPCB certified',
  'FSSAI certified',
  'made in India',
  'At Every Desk',
  'AED',
  'paper bottle wholesale',
  'custom paper bottle',
  'paper bottle branding',
];

export const PAGE_KEYWORDS = {
  home: [
    'Paper Bottle',
    'Paper Bottle Manufacturer',
    'Paper Bottle India',
    '100% compostable paper bottle',
  ],
  products: [
    'Paper Bottle',
    'Paper Bottle Manufacturer',
    'Paper Bottle India',
    '100% compostable paper bottle',
    'paper bottle products',
    'paper bottle sizes',
    'paper bottle customization',
    'paper bottle printing',
    'patented paper bottle',
  ],
  otherProducts: [
    'PLA pellets',
    'PLA pellets injection molding',
    'PLA pellets 3D printing',
    'compostable preforms',
    'compostable caps',
    'compostable bags India',
    'compostable food packaging',
    'compostable stretch film',
  ],
  services: [
    'paper bottle consulting',
    'paper bottle design services',
    'compostable packaging services',
    'sustainable packaging solutions',
  ],
  about: [
    'about paper bottle manufacturer',
    'paper bottle company India',
    'compostable packaging company',
  ],
  contact: [
    'contact paper bottle manufacturer',
    'paper bottle inquiry',
    'paper bottle quote',
  ],
  notFound: ['404', 'page not found'],
};

export const SEO_TITLES = {
  home: 'Paper Bottle India | 100% Compostable Paper Bottle | AED',
  products: '100% Compostable Paper Bottle | 500ml · 750ml · 1L | AED',
  otherProducts: 'Other Compostable Products | Bags & Packaging | AED',
  services: 'Paper Bottle & Packaging Services | At Every Desk',
  about: 'About AED | Paper Bottle Manufacturer India',
  contact: 'Contact Paper Bottle Manufacturer | At Every Desk',
  notFound: '404 - Page Not Found | At Every Desk',
};

export const SEO_DESCRIPTIONS = {
  home:
    'Paper Bottle India — 100% compostable paper bottle manufacturer. Available in 500ml, 750ml & 1L. CIPET, CPCB & FSSAI certified. Wholesale & custom branding.',
  products:
    '100% compostable paper bottles in 500ml, 750ml and 1L. Paper Bottle India manufacturer. Custom branding, patented design. Made for beverages.',
  otherProducts:
    'PLA pellets, compostable bags, preforms, caps, food packaging & stretch film from At Every Desk. CPCB, CIPET, TUV Austria & EN-13432 certified bioplastics.',
  about:
    'Paper Bottle India manufacturer — At Every Desk (AED) offers 100% compostable paper bottles, bags and packaging. CIPET, CPCB & FSSAI certified.',
  services:
    'Paper Bottle India services — 100% compostable paper bottle design, manufacturing, branding and consulting. CIPET, CPCB & FSSAI certified.',
  contact:
    'Contact Paper Bottle India manufacturer for 100% compostable paper bottle quotes. Call +91 9377004949 or email info@ateverydesk.com.',
  notFound:
    "The page you're looking for doesn't exist. Return to At Every Desk homepage or browse our paper bottle products.",
};

function dedupeKeywords(keywords) {
  const seen = new Set();
  const result = [];

  for (const keyword of keywords) {
    const normalized = keyword.trim();
    if (!normalized) continue;
    const key = normalized.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    result.push(normalized);
  }

  return result;
}

function parseKeywordString(keywordString) {
  return keywordString.split(',').map((term) => term.trim()).filter(Boolean);
}

export const EXTENDED_KEYWORDS = dedupeKeywords(parseKeywordString(RAW_LLM_KEYWORDS));

const META_KEYWORD_LIMIT = 500;

export function getMetaKeywords(page = 'home') {
  const combined = dedupeKeywords([
    ...PRIMARY_KEYWORDS,
    ...SECONDARY_KEYWORDS,
    ...(PAGE_KEYWORDS[page] || []),
  ]);

  let result = '';
  for (const keyword of combined) {
    const next = result ? `${result}, ${keyword}` : keyword;
    if (next.length > META_KEYWORD_LIMIT) break;
    result = next;
  }

  return result;
}
